import { render, staticRenderFns } from "./PanelContentItemActions.vue?vue&type=template&id=efdf6d90&"
import script from "./PanelContentItemActions.vue?vue&type=script&lang=ts&"
export * from "./PanelContentItemActions.vue?vue&type=script&lang=ts&"
import style0 from "./PanelContentItemActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
